import { LanguageContext } from 'context/languageContext';
import { useContext, useState } from 'react';
import GhostButton from 'Common/Buttons/Ghost';
import EuroProfileIcon from 'Common/Icons/EuroProfile';

import styles from './index.module.css';
import { CustomButton } from '@/Components/CustomButton';
import { C2cAvatar } from '@/Common/Icons/C2cAvatar';
import { PaymentSystemInfo } from '@/Components/InformationModals/PaymentSystemInfo';

const PaymentSystem = () => {
  const { t } = useContext(LanguageContext);

  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const closeMoreInfo = () => {
    setIsOpenInfo(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>{t('internal')}</div>
      <div className={styles.content_wrapper}>
        <div className={styles.left_side}>
          <p style={{ maxWidth: 490 }}>
            <span style={{ marginRight: 6 }}>{t('connect')}</span>
            <span className={styles.leftSpan}>
              <img src={'/assets/svg/tonkeeper.svg'} alt="ton" />{' '}
              <span>{t('tonKeeper')}</span>
            </span>{' '}
            {t('usePlatform')}{' '}
            <span style={{ fontWeight: 800 }}>{t('tokens')}</span>{' '}
            <span>{t('bySharingYourBelongings')}</span>
          </p>
          <p style={{ maxWidth: 450 }}>
            <span>{t('payIn')}</span>{' '}
            <span style={{ fontWeight: 800 }}>{t('tokens')}</span>{' '}
            <span>{t('earnTokensC2C')}</span>
          </p>
          <div style={{ marginTop: '32px' }}>
            <CustomButton
              sizeButton="medium"
              typeButton="secondary"
              style={{ minWidth: 106 }}
              onClick={() => {
                setIsOpenInfo(true);
              }}
            >
              <div style={{ color: '#000' }}>{t('moreDetails')}</div>
            </CustomButton>
          </div>
        </div>
        <div className={styles.right_side}>
          <div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <C2cAvatar
                style={{
                  width: '22px',
                  height: '26px',
                  backgroundPosition: 'center',
                  backgroundSize: '22px 26px',
                }}
              />
              {t('C2CToknes')}
            </div>
            <span>0% {t('Fee')}</span>
          </div>
          <div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <img src={'/assets/svg/visa_card.svg'} alt="visa" />
              <img src={'/assets/svg/mstercard.svg'} alt="visa" />
            </div>
            <span>10% {t('Fee')}</span>
          </div>
        </div>
      </div>
      <PaymentSystemInfo isOpen={isOpenInfo} onClose={closeMoreInfo} />
    </div>
  );
};

export default PaymentSystem;
